const DEFAULT_NODE = {
  shape: 'dot',
  size: 25,
  borderColor: '#666666',
  backgroundColor: '#191919',
  borderWidth: 1,
  fontColor: '#777',
  fontSize: 14,
  fontFace: 'Arial',
};

export default class GroupStyleResolver {
  constructor(groups) {
    this._groups = {};
    if (groups) this.setGroups(groups);
  }

  setGroups(groups) {
    this._groups = {};
    for (const name in groups) {
      const g = groups[name];
      this._groups[name] = {
        shape: g.shape || 'dot',
        size: g.size !== undefined ? g.size : DEFAULT_NODE.size,
        borderColor: g.color?.border || DEFAULT_NODE.borderColor,
        backgroundColor: g.color?.background || DEFAULT_NODE.backgroundColor,
        borderWidth: g.color?.borderWidth || g.borderWidth || DEFAULT_NODE.borderWidth,
        fontColor: g.font?.color || DEFAULT_NODE.fontColor,
        fontSize: g.font?.size || DEFAULT_NODE.fontSize,
        fontFace: g.font?.face || DEFAULT_NODE.fontFace,
        ctxRenderer: g.ctxRenderer || null,
      };
    }
  }

  resolve(node) {
    const group = node.group && this._groups[node.group];
    const base = group || this._groups['default'] || DEFAULT_NODE;
    const nodeColor = node.color;
    return {
      shape: base.shape,
      size: node.size || base.size,
      borderColor: nodeColor?.border || base.borderColor,
      backgroundColor: nodeColor?.background || base.backgroundColor,
      borderWidth: base.borderWidth,
      fontColor: node.font?.color || base.fontColor,
      fontSize: node.font?.size || base.fontSize,
      fontFace: node.font?.face || base.fontFace,
      ctxRenderer: base.ctxRenderer,
    };
  }
}
